import { Loading } from '#loading/loading.component.tsx';

import type { StaticLoaderProps } from './types/static-loader.props';

/**
 * StaticLoader component renders a loading indicator with customizable type and target reference.
 *
 * @param target - The ref of the target element where the loader should be displayed.
 * @param type - The style of the loader, defaults to 'grid'.
 * @returns A Loading component configured with the specified props.
 */
export const StaticLoader = ({ target, type = 'grid' }: StaticLoaderProps) => {
  return (
    <Loading
      size={2}
      targetRef={target}
      type={type}
    />
  );
};
